<template>
  <v-card :loading="loadingSave">
    <v-card-title>Adicionar Anúncio</v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-select
          :items="['Imagem', 'Vídeo']"
          label="Tipo de mídia"
          outlined
          v-model="$store.state.ads.editedAds.type"
        ></v-select>

        <v-row>
          <v-col md="4">
            <v-switch
              v-model="$store.state.ads.editedAds.status"
              inset
              :label="
                'Status ' +
                ($store.state.ads.editedAds.status ? 'ativo' : 'inativo')
              "
            >
            </v-switch>
          </v-col>
          <v-col md="4">
        <v-switch
          v-model="$store.state.ads.editedAds.showQr"
          inset
          :label="'QRcode'"
        />
        </v-col>
          <v-col md="4" v-if="$store.state.ads.editedAds.type == 'Imagem'">
            <v-text-field style="margin-top: 20px"
              hide-details=""
              v-model="$store.state.ads.editedAds.time"
              label="Tempo de exibição"
              dense
              type="number"
              :rules="[
                (v) =>
                  v > 0 || 'Tempo em que a notícia ficará na tela do totem',
              ]"
            ></v-text-field> Segundos
          </v-col>
        </v-row>
        <v-row><picker></picker></v-row>

        <v-text-field
          outlined
          :title="'Nome de identificação deste anúncio'"
          label="Nome"
          v-model="$store.state.ads.editedAds.name"
          :rules="validateName"
          required
          small
        ></v-text-field>

        <v-text-field
          outlined
          :title="'Cole aqui o link de para o qr-code'"
          label="Cole aqui o link de para o qr-code"
          v-model="$store.state.ads.editedAds.qrcode"
          :rules="validateQr"
          required
          small
        ></v-text-field>

        <v-row v-if="!!$store.state.ads.editedAds.type">
          <v-col>
            <v-text-field
              outlined
              :readonly="readonlyFile"
              :title="'Cole aqui o link de mídia ou faça upload clicando no botão ao lado'"
              label="Cole aqui o link de mídia ou faça upload"
              v-model="$store.state.ads.editedAds.link"
              :rules="validateLink"
              required
              small
            ></v-text-field>
          </v-col>
          <v-col>
            <v-file-input
              class="file"
              label="Carregar mídia"
              filled
              prepend-icon="mdi-camera"
              :accept="
                $store.state.ads.editedAds.type == 'Imagem'
                  ? 'image/*'
                  : 'video/*'
              "
              @change="changeFile"
              :loading="loadingFile"
            ></v-file-input>
          </v-col>
        </v-row>

        <v-card-actions v-if="!!$store.state.ads.editedAds.type">
          <v-btn
            color="error"
            class="mr-4"
            @click="$router.push('/advertisements/list')"
            >cancelar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!valid"
            color="success"
            class="mr-4"
            :loading="loadingSave"
            @click="save"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { updateAds } from "../../../services/ads";
// import { createNews, updateNews } from "../../services/news";
//import sendFile from "../../../services/sendFile";
import { sendImageAds, sendVideoAds, getFile } from "../../../services/repository";
import picker from "./datePicker";
// import { changeCrowller } from "../../services/crowller";
const timeout = time => new Promise(resolve => setTimeout(resolve, time || 3000))
export default {
  components: { picker },
  data: () => ({
    ticket: 0,
    loadingSave: false,
    loadingFile: false,
    readonlyFile: false,
    link: "",
    valid: false,
    validateLink: [
      (v) =>
        (v || []).length > 0 || "Link de mídia para este anúncio é obrigatório",
    ],
    validateQr: [
      (v) =>
        (v || []).length > 0 ||
        "Link para o QRcode é obrigatório, formato: https://meuAnuncio.com.br",
    ],
    validateName: [(v) => (v || []).length > 0 || "O nome é obrigatório"],
  }),
   watch: {
    loadingFile(value){
      this.$store.commit("setLoading", value)
    }
  },
  methods: {
    async loopGetFile(){
      await timeout()
      const data = await getFile(this.ticket).catch(()=>false)
      if(!data){
        this.loadingFile = false;
        this.$store.commit(
            "failed",
            "Falha ao carregar arquivo, verfica se o arquivo corresponde a uma imagem ou vídeo ou você pode ter perdido acesso à cloudnary"
          );
      }
      if(data && data.url){
        this.loadingFile = false;
        this.readonlyFile = true;
        this.$store.commit("success", "URL da mídia gerada com sucesso");
        return this.$store.state.ads.editedAds.link = data.url
      }
      this.loopGetFile()
    },
    sendVideo(data) {
      sendVideoAds(data)
        .then((status) => {
          this.ticket = status.ticket
          return this.loopGetFile()
        })
        .catch(() => {
          this.loadingFile = false;
          this.$store.commit(
            "failed",
            "Falha ao carregar arquivo, verfica se o arquivo corresponde a uma imagem ou vídeo ou você pode ter perdido acesso à cloudnary"
          );
        });
    },
    sendImage(data) {
      sendImageAds(data)
        .then((url) => {
          //const urlMount = url.split('upload/')
          this.$store.state.ads.editedAds.link = url.url; //urlMount[0] + 'upload/c_fill,g_auto,h_1920,w_1080/' + urlMount[1]
          this.loadingFile = false;
          this.$store.commit("success", "URL da mídia gerada com sucesso");
          this.readonlyFile = true;
        })
        .catch(() => {
          this.loadingFile = false;
          this.$store.commit(
            "failed",
            "Falha ao carregar arquivo, verfica se o arquivo corresponde a uma imagem ou vídeo ou você pode ter perdido acesso à cloudnary"
          );
        });
    },
    async changeFile(data) {
      if (!data) return (this.$store.state.ads.editedAds.link = "");
      this.loadingFile = true;
      if (this.$store.state.ads.editedAds.type == "Imagem") {
        this.sendImage(data);
      } else {
        this.sendVideo(data);
      }
    },
    parserDate() {
      if (this.$store.state.ads.editedAds.startDate.length == 10) {
        this.$store.state.ads.editedAds.startDate = new Date(
          this.$store.state.ads.editedAds.startDate
            .split("/")
            .reverse()
            .join("-") + " "
        );
        this.$store.state.ads.editedAds.endDate = new Date(
          this.$store.state.ads.editedAds.endDate
            .split("/")
            .reverse()
            .join("-") + " "
        );
      }
      //.startDate.split('/').reverse().join('-') + ' '
    },
    async save() {
      const isValid = this.$refs.form.validate();
      if (!isValid) return;
      this.parserDate();
      this.loadingSave = true;
      this.$store.state.ads.editedAds.user = this.$store.state.user;
      updateAds([this.$store.state.ads.editedAds])
        .then((data) => {
          data.startDate = new Date(data.startDate).toLocaleDateString();
          data.endDate = new Date(data.endDate).toLocaleDateString();
          this.$store.state.ads.data.push(data);
          this.loadingSave = false;
          this.$store.commit("success", "Anúncio cadastrado com sucesso");
          this.$router.push("/advertisements/list");
        })
        .catch((err) => {
          this.$store.commit("failed", err);
          this.loadingSave = false;
        });
    },
    validUrl() {},
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
  beforeDestroy() {
    this.$store.commit("reset");
  },
};
</script>

<style scoped>
.file >>> * {
  cursor: pointer;
}
</style>